import { render, staticRenderFns } from "./SelectInputConfig.vue?vue&type=template&id=687af8d4&scoped=true"
import script from "./SelectInputConfig.vue?vue&type=script&lang=js"
export * from "./SelectInputConfig.vue?vue&type=script&lang=js"
import style0 from "./SelectInputConfig.vue?vue&type=style&index=0&id=687af8d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687af8d4",
  null
  
)

export default component.exports